/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

export const maxProfileEntriesPerSection = 50 as const

export type MaxProfileEntriesPerSection = typeof maxProfileEntriesPerSection
